<template>
  <UserLoginFormMobile/>
</template>

<script>
import UserLoginFormMobile from '@/components/Partials/UserLoginFormMobile.vue';

export default {
  name: 'UserLoginView',
  components: {
    UserLoginFormMobile,
  },
  mounted() {
    this.redirectIfLogged();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    user() {
      this.redirectIfLogged();
    },
  },
  methods: {
    redirectIfLogged() {
      if (this.$store.state.user) {
        this.$router.push('/');
      }
    },
  },
};
</script>

<style scoped>
.arrowDown {
  width: 0;
  height: 0;
  margin-left: 49.5%;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}
</style>
